import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { brandActions } from '../../../redux/actions/brand-actions';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import {AiOutlineDelete} from 'react-icons/ai';


const soundUrl = `https://ia800203.us.archive.org/14/items/slack_sfx/been_tree.mp3`
const notificationSound = new Audio(soundUrl)

class NotificationContainer extends Component {
  constructor() {
    super()

    this.state = {
      count: 0,
      isAnimating: false,
      mute: false,
      notifications: [
        {
          brand: 'hurley',
          id: '1',
          message: [{ "line": 1, "line_no": 1, "message": "SQLSTATE[HY000]: General error: 1366 Incorrect integer value: 'UPC' for column 'upc' at row 1 (SQL: insert into `product_hrly` (`pocut`, `style`, `upc`, `color`, `stylename`, `qty`, `msrp`, `tag`, `size`, `country`, `vendor`, `yn`, `wh`, `art`, `poline`, `brand_data_definition_id`, `brand_id`, `brand`, `created_at`, `updated_at`) values (?, Style#, UPC, Color, Style_Name, Qty, MSRP, Tag, Size, Country, Vendor, YN, W/H, ART, PO_line\r, 17, 4, hurley, 2019-12-19 12:05:05, 2019-12-19 12:05:05))", "file_path": "hrly/product_feeds/02469_20191016041007.txt", "parameters": { "wh": "W/H", "yn": "YN", "art": "ART", "qty": "Qty", "tag": "Tag", "upc": "UPC", "msrp": "MSRP", "size": "Size", "brand": "hurley", "color": "Color", "pocut": null, "style": "Style#", "poline": "PO_line\r", "vendor": "Vendor", "country": "Country", "brand_id": 4, "stylename": "Style_Name", "created_at": "2019-12-19T12:05:05.047152Z", "updated_at": "2019-12-19T12:05:05.047164Z", "brand_data_definition_id": 17 } }]
        },
        {
          brand: 'everLane',
          id: '2',
          message: [{ "line": 1, "line_no": 1, "message": "SQLSTATE[HY000]: General error: 1366 Incorrect integer value: 'UPC' for column 'upc' at row 1 (SQL: insert into `product_hrly` (`pocut`, `style`, `upc`, `color`, `stylename`, `qty`, `msrp`, `tag`, `size`, `country`, `vendor`, `yn`, `wh`, `art`, `poline`, `brand_data_definition_id`, `brand_id`, `brand`, `created_at`, `updated_at`) values (?, Style#, UPC, Color, Style_Name, Qty, MSRP, Tag, Size, Country, Vendor, YN, W/H, ART, PO_line\r, 17, 4, hurley, 2019-12-19 12:05:05, 2019-12-19 12:05:05))", "file_path": "hrly/product_feeds/02469_20191016041007.txt", "parameters": { "wh": "W/H", "yn": "YN", "art": "ART", "qty": "Qty", "tag": "Tag", "upc": "UPC", "msrp": "MSRP", "size": "Size", "brand": "hurley", "color": "Color", "pocut": null, "style": "Style#", "poline": "PO_line\r", "vendor": "Vendor", "country": "Country", "brand_id": 4, "stylename": "Style_Name", "created_at": "2019-12-19T12:05:05.047152Z", "updated_at": "2019-12-19T12:05:05.047164Z", "brand_data_definition_id": 17 } }]
        }

      ]
    }

    this.handleClick = this.handleClick.bind(this)
    this.notify = this.notify.bind(this)
  }

  render() {
    const { count, mute, isAnimating } = this.state
    return (
      <OverlayTrigger className="notifications" trigger="focus" placement="bottom" overlay={
        <Popover id="notifications">
          <table className="table blank notifications">
            <tbody>
              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>

              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>

              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>

              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>

              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>

              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>

              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>

              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>

              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>

              <tr>
                <td width="90%">
                  <a href="#!"><span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span></a>
                </td>
                <td width="10%">
                  <a href="#!"><AiOutlineDelete /></a>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="viewAllErrors">
            <Link to="/Admin/brands/syncErrors">
              View All
            </Link>
          </div>
        </Popover>
      }>
        <div>
          <Notification
            count={count}
            isAnimating={isAnimating}
            mute={mute} />
        </div>
      </OverlayTrigger>
    )
  }

  notify() {
    if (this.state.mute) {
      return null
    }
    let totalCount = this.state.count;
    this.setState({
      count: totalCount += 1,
      isAnimating: !this.state.mute ? true : false
    })

    notificationSound.play()
    setTimeout(() => this.setState({ isAnimating: false }), 1000)
  }

  componentDidMount() {
    //this.countNotifications = setInterval(this.notify, 2000)
  }

  componentWillUnmount() {
    clearInterval(this.countNotifications)
  }


  handleClick() {
    this.setState({ mute: !this.state.mute })
    console.log(this.state)
  }
}


const NotificationIcon = () => (
  <svg width='2.3em' height='2.3em' viewBox='0 0 21 20'>
    <g transform='translate(2, 0)'>
      <path className='notification-bell__bow' d='M15,8.5 C15,5.43 12.86,2.86 10,2.18 L10,1.5 C10,0.671572875 9.32842712,0 8.5,0 C7.67157288,0 7,0.671572875 7,1.5 L7,2.18 C4.13,2.86 2,5.43 2,8.5 L2,14 L0,16 L0,17 L17,17 L17,16 L15,14 L15,8.5 Z' />
      <path className='notification-bell__clapper' d='M2.5,2 C2.64,2 2.77,2 2.9,1.96 C3.55,1.82 4.09,1.38 4.34,0.78 C4.44,0.54 4.5,0.27 4.5,0 L0.5,0 C0.5,1.1045695 1.3954305,2 2.5,2 L2.5,2 Z' />
    </g>
  </svg>
)

const Notification = ({ count, mute, isAnimating }) => (
  <button
    className={`notification-bell ${isAnimating ? 'is-animating' : ''} ${mute ? 'is-muted' : ''}`}
    data-count={count > 9 ? '9+' : count}>
    <NotificationIcon />
  </button>
)


const mapDispatchToProps = dispatch => {
  return ({
    getBrandSettingsCall: (brandId) => { dispatch(brandActions.getBrandSettings(brandId)) },
    updateBrandSettingsCall: (brandId, data) => { return dispatch(brandActions.updateBrandSettings(brandId, data)) },
  });
};


function mapStateToProps(state) {
  const { brand_settings } = state.brandReducer;
  return {
    brand_settings
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationContainer));



// WEBPACK FOOTER //
// ./src/components/Admin/Header/Bell.jsx